/**
 * 画面风格与「项目类型」：setupDictionary 每条 visual_style 可在 description 首部写
 * [[scopes:short,product,mg]]（由后端解析为 scopes 数组）；未配置 scopes 时，商品讲解 / MG 动画
 * 使用下列 id 白名单与字典交集作为兜底（与 fa_ai_dictionary.visual_style.code 一致）。
 */

export const VISUAL_STYLE_IDS_PRODUCT_COMMERCE_FALLBACK = [
  1, 2, 4, 5, 6, 7, 9, 10, 12, 13, 14, 15, 16, 18, 19, 22, 24, 25, 28, 29, 30, 32
];

export const VISUAL_STYLE_IDS_MG_AD_FALLBACK = [
  2, 4, 5, 6, 12, 14, 15, 16, 19, 22, 23, 25, 26, 27, 29, 30, 31, 33
];

/** @returns {'short'|'product'|'mg'} */
export function projectTypeToVisualScopeKey(projectType) {
  const t = String(projectType || "").trim();
  if (t === "商品讲解") return "product";
  if (t === "MG动画" || /^mg/i.test(t)) return "mg";
  return "short";
}

/** @returns {number[]|null} null 表示不按 id 兜底（短剧走全量） */
export function visualStyleFallbackIdsForProjectType(projectType) {
  const t = String(projectType || "").trim();
  if (t === "商品讲解") return VISUAL_STYLE_IDS_PRODUCT_COMMERCE_FALLBACK.slice();
  if (t === "MG动画" || /^mg/i.test(t)) return VISUAL_STYLE_IDS_MG_AD_FALLBACK.slice();
  return null;
}
